export const demoLogin = 'demo_user_mode';
